<template>
  <div class="pageBox">
    <div class="content">
      <div class="applicationBox">
        <div class="searchBox">
          <div class="flex1">
            <el-input class="searchBtn" placeholder="按应用名称、应用包名搜索应用" clearable v-model.trim="keyword"
                      @keyup.enter.native="search()" @change="onEmpty()">
              <el-button class="fontSize18 searchIcon" slot="append" icon="el-icon-search" @click="search()"
                         :disabled="this.keyword==''"></el-button>
            </el-input>
          </div>
          <div class="btnBox">
            <div class="authenticationBtn" @click="onCreatedApp()">创建应用</div>
          </div>
        </div>
        <div v-if="this.tableData.length">
          <div class="listBox">
            <div class="item" v-for="(item,index) in tableData" :key="index ">
              <div class="appBox">
                <div class="appIcon">
                  <img :src="item.appIcon" width="100%" height="100%" alt="">
                </div>
                <div class="appInfo">
                  <el-tooltip :content="item.appName" placement="top" :disabled="isShowTooltipAppName">
                    <h2 class="appName ellipsis" @mouseover="onMouseOverApkName(item.appName )">
                      <span :ref='item.appName'>{{ item.appName }}</span>
                    </h2>
                  </el-tooltip>
                  <div class="infoItem">
                    <div class="label">应用包名</div>
                    <el-tooltip :content="item.appPackage" placement="top" :disabled="isShowTooltipAppPackage">
                      <div class="msg ellipsis" @mouseover="onMouseOverApkPackage(item.appPackage )"><span
                          :ref='item.appPackage'>{{ item.appPackage }}</span></div>
                    </el-tooltip>
                  </div>
                  <div class="infoItem">
                    <div class="label">创建时间</div>
                    <div class="msg ellipsis">{{ item.createTime | parseTime() }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="label">应用状态</div>
                    <div class="msg ellipsis" v-if="item.freezeState =='2'">
                      <template v-for="(type,index) in (item.freezeType || '').split('、')">
                        <span :key="index">{{ type }} </span>
                      </template>
                      <span @click="onFreezeShow(item.id,'freeze')" class="blue cursor">查看原因</span>
                    </div>
                    <div class="msg ellipsis" v-else-if="item.state == '1'">待审核</div>
                    <div class="msg ellipsis" v-else-if="item.state == '3'">
                      <span>创建失败</span>
                      <span @click="onFreezeShow(item.id,'reject')" class="blue cursor">查看原因</span>
                    </div>
                    <div class="msg ellipsis" v-else>正常</div>
                  </div>
                  <div class="infoItem">
                    <div class="label">链接数量</div>
                    <div class="msg ellipsis">{{ item.linkCount }}</div>
                  </div>
                </div>
              </div>
              <div class="btnBox">
                <template v-if="item.state == 2">
                  <router-link
                      class="authenticationBtn"
                      tag="el-button"
                      :to="{path:'/console/appLink/app/appData',query:{appId:item.id}}">
                    数据统计
                  </router-link>
                  <router-link
                      class="authenticationBtn"
                      tag="el-button"
                      :to="{path:'/console/appLink/link/list',query:{appId:item.id,appName:item.appName}}">
                    链接管理
                  </router-link>
                </template>
                <router-link
                    v-if="item.state == '3'"
                    class="authenticationBtn"
                    tag="el-button"
                    :to="{path:'/console/appLink/app/form',query:{appId:item.id}}">
                  重新申请
                </router-link>
              </div>
            </div>
          </div>
          <div class="margin-t30 text-right">
            <el-pagination
                class="paginationBox"
                background
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="page"
                :page-sizes="[6,12,24,36]"
                :page-size="perPage"
                :total="total"
                layout="total, prev, pager, next, sizes">
            </el-pagination>
          </div>
        </div>
        <div class="listBox" v-else>
          <div class="noDataBox">
            <img class="img" src="@/assets/img/console/noData.jpg" alt="">
            <div v-if="keyword && !this.tableData.length && isSearch">
              <p class="msg">未能找到“ {{ this.msg }} ”相关应用</p>
            </div>
            <div v-if="!isSearch && !this.tableData.length">
              <p class="msg">您还未创建应用，请先创建应用</p>
              <!-- <div class="authenticationBtn" @click="onCreatedApp()">认证新应用</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <freezeReason ref="freezeReason"></freezeReason>
  </div>
</template>
<script>
import freezeReason from "./dialog/freezeReason.vue";

export default {
  components: {
    freezeReason,
  },
  data() {
    return {
      isLookStep: false, //存缓存,
      appPackage: "",
      page: 1,
      perPage: 6,
      total: 0,
      tableData: [],//金标list
      isShowTooltipAppPackage: true,
      isShowTooltipAppName: true,
      msg: "",
      keyword: "",//关键字搜索
      isSearch: false,
    };
  },
  activated() {
    this.queryAppList(); //获取APP应用list
  },
  watch: {
    '$route.query.date'() {
      // this.page = 1;
      this.queryAppList();
    },
  },
  methods: {
    //打开冻结原因,type:freeze冻结、reject申请驳回
    onFreezeShow(id, type) {
      this.$refs['freezeReason'].show(id, type)
    },
    // 内容超出，显示文字提示内容
    onMouseOverApkPackage(str) {
      const tag = this.$refs[str];
      const parentWidth = tag[0].parentNode.offsetWidth;// 获取元素父级可视宽度要减去应用包名的长度
      const contentWidth = tag[0].offsetWidth; // 获取元素可视宽度
      this.isShowTooltipAppPackage = contentWidth <= parentWidth;
    },
    // 内容超出，显示文字提示内容
    onMouseOverApkName(str) {

      const tag = this.$refs[str];
      const parentWidth = tag[0].parentNode.offsetWidth;// 获取元素父级可视宽度要减去应用包名的长度
      const contentWidth = tag[0].offsetWidth; // 获取元素可视宽度
      this.isShowTooltipAppName = contentWidth <= parentWidth;
    },
    queryAppList() {
      this.$apis.consoleSever
          .queryPage({
            keyword: this.keyword,
            page: this.page,
            perPage: this.perPage,
          })
          .then(res => {
            if (res.code == 0) {
              this.tableData = res.data.data;
              this.total = res.data.total;
              this.msg = this.keyword;
              this.isSearch = res.data.isSearch;
            } else {
              this.$message.error(res.message);
            }
          });
    },
    //搜索
    onEmpty() {
      if (this.keyword == "") {
        this.search();
      }
    },
    search() {
      this.page = 1;
      this.queryAppList();
    },
    //每页多少条
    sizeChange(val) {
      this.perPage = val;
      this.queryAppList();
    },
    //翻页
    currentChange(val) {
      this.page = val;
      this.queryAppList();
    },
    //认证步骤弹出
    lookStep() {
      this.isLookStep = true;
    },
    //认证步骤关闭
    closeStep(data) {
      this.isLookStep = data;
    },
    //创建应用
    onCreatedApp() {
      this.$router.push("/console/appLink/app/form");
    },
  },
};
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .content {
    background: #fff;
    box-shadow: $--background-shadow-base;
    overflow: hidden;

    .applicationBox {
      padding: 25px;

      .searchBox {
        padding-left: 25px;
        display: flex;
        justify-content: space-between;

        .flex1 {
          .searchBtn {
            width: 60% !important;
            height: 48px;

            &:hover {
              opacity: 0.7;
            }

            /deep/ .el-input__inner {
              height: 48px;
            }

            .searchIcon {
              background: #fff;
            }
          }

          span {
            margin-left: 34px;
            color: #666666;
            font-size: 14px;
          }
        }

        .btnBox {
          display: flex;
          margin-right: 18px;

          .authenticationBtn {
            width: 156px;
            height: 39px;
            background: #2E84FC;
            border-radius: 10px;
            font-size: 16px;
            line-height: 39px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            margin: 0 10px;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }

      .listBox {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        width: 100%;
        margin-top: 20px;
        min-height: 680px;

        .item {
          margin: 0 25px;
          position: relative;
          width: 30%;
          height: 320px;
          border-radius: 5px;
          border: 1px solid #DFDFDF;
          margin-bottom: 20px;
          padding-bottom: 55px;
          overflow: hidden;

          .appBox {
            // display: flex;    
            // justify-content: space-between;
            overflow: hidden;
            padding: 20px 30px;

            .appIcon {
              float: left;
              width: 25%;
              height: 20%;
              border-radius: 10px;
            }

            .appInfo {
              float: right;
              width: 70%;

              .appName {
                margin-bottom: 12px;
                width: 80%;
                font-size: 24px;
                color: #000000;
                font-weight: bold;
                cursor: pointer;
              }

              .infoItem {
                display: flex;
                // width: 90%;
                line-height: 32px;
                color: #333;
                font-weight: bold;
                font-size: 14px;
                border-bottom: 1px solid #ccc;

                .label {
                  width: 30%;
                  min-width: 60px;
                }

                .msg {
                  justify-content: space-between;
                  width: 70%;
                  color: #666;
                  font-weight: bold;
                  display: flex;
                  flex-direction: column;
                  & > span:not(:first-child) {
                    line-height: 26px;
                  }
                }
              }

              .infoItem:last-child() {
                border-bottom: none;
              }
            }
          }

          .btnBox {
            position: absolute;
            bottom: 10px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 100%;
            height: 55px;
            right: 20px;

            .authenticationBtn {
              background: #2E84FC;
              color: #fff;
              cursor: pointer;
              margin: 0 10px;

              &:hover {
                opacity: 0.9;
              }
            }
          }
        }

        .noDataBox {
          width: 350px;
          height: 300px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          flex-direction: column;
          align-items: center;

          .img {
            width: 338px;
            height: 211px;
          }

          .msg {
            margin-top: 20px;
            color: #ccc;
            margin-bottom: 22px;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>

